import { render } from "./AppNavActions.vue?vue&type=template&id=116cab8d"
import script from "./AppNavActions.vue?vue&type=script&lang=ts"
export * from "./AppNavActions.vue?vue&type=script&lang=ts"
script.render = render

export default script